
import axios from 'axios';


/* const headers = {
  contentType: 'application/json',
  //xsrfHeaderName: 'X-CSRFToken',
  //xsrfCookieName: 'csrftoken',
  //withCredentials: true,
}; */


const BASE_URL = process.env.VUE_APP_BACKEND_URL || '';

const apiService = axios.create({
    timeout: 30000,
    //headers,
    baseURL: BASE_URL,
});


apiService.interceptors.response.use(
    (response) => {
        if (!response || typeof response === 'undefined') {
        return { success: false };
        }
        if ('data' in response) {
        return response.data;
        }
        return response;
    },
    (error) => {
        if (!error.response) {
        return null;
        }
        if (error.response.status === 401) {
        console.log('TOKEN ERROR - RELOADING');

        return error;
        }
        throw error;
    },
);

apiService.interceptors.request.use((config) => {
    return config;
});

const PLANS_ENDPOINT = 'plans/';

export default {
    get_plans() {
        return apiService.get(`${PLANS_ENDPOINT}`);
    },
    PLANS_ENDPOINT

}